"use client";

import { useState } from "react";
import Link from "next/link";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
import TextInput from "../Form/Inputs/TextInput/TextInput";
// import { track } from "../../utils";
import { REQUEST_RESET_PASSWORD_MUTATION } from "../../../apollo/queries";
import formatAPIErrors from "../../utils/formatAPIErrors";
import SubmitButton from "../SubmitButton/SubmitButton";
import CheckmarkIcon from "../svgs/icons/CheckmarkIcon";
// import { AnalyticsEventName } from "../../types";

const RequestResetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email.")
    .required("Please enter your email."),
});

const uiMessages = {
  userRequest:
    "Forgot your password? No problem. We'll send you an email with instructions on how to reset it.",
  pinMigration:
    "To enhance security, your 4 digit pin has expired. We'll send you an email with instructions to set a new password.",
  success:
    "Request sent! Please check your email for a link to reset your password.",
};

const RequestResetPassword = ({ origin = "userRequest" }) => {
  const [activeMessage, setActiveMessage] = useState(uiMessages[origin]);
  const [requestResetPasswordMutation] = useMutation(
    REQUEST_RESET_PASSWORD_MUTATION,
  );

  return (
    <div className="flex flex-col w-full items-center justify-start mb-auto md:max-w-[640px]">
      {activeMessage === uiMessages.success ? (
        <CheckmarkIcon className="fill-blue w-16 h-16 mb-5" />
      ) : null}
      <div className="text-lg mb-8 w-full text-center self-center flex flex-col gap-y-8 md:w-3/4">
        <p>{activeMessage}</p>
        {activeMessage === uiMessages.success ? (
          <p>
            Haven&#39;t received your email? Check your spam folder or request a
            reset link again.
          </p>
        ) : null}
      </div>
      <Formik
        initialValues={{ email: "" }}
        validationSchema={RequestResetPasswordSchema}
        onSubmit={async (
          { email },
          { resetForm, setSubmitting, setErrors },
        ) => {
          try {
            await requestResetPasswordMutation({
              variables: {
                input: {
                  email,
                },
              },
            });
            setActiveMessage(uiMessages.success);
            resetForm();
            window.scrollTo(0, 0);
          } catch (error) {
            // TODO: handle errors
            // setErrors(error.graphQLErrors[0].extensions.errors);
            setErrors(formatAPIErrors(error));
            console.error(error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <Form
            className="flex flex-col text-lg w-full p-0 mb-4"
            onSubmit={handleSubmit}
          >
            <TextInput
              wrapperClassName="mb-8"
              name="email"
              type="email"
              placeholder="Your Sparks email address*"
            />
            <SubmitButton
              className="bg-blue"
              text="Email me"
              submittingText="Sending e-mail"
              isSubmitting={isSubmitting}
            />
          </Form>
        )}
      </Formik>
      <div className="flex flex-col gap-y-4">
        <span className="text-center text-sm">
          Don&#39;t have an account?&nbsp;
          <Link className="text-red" href="/sign-up">
            Sign Up
          </Link>
        </span>
        <span className="text-center text-sm">
          {activeMessage === uiMessages.pinMigration &&
            "Already set your password? "}
          Return to{" "}
          <Link className="text-blue" href="/sign-in">
            Sign In
          </Link>
        </span>
      </div>
    </div>
  );
};

export default RequestResetPassword;
